module.exports = new __parcel__URL__("view-unavailable-error.ffa799d6.svg").toString();